import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import {environment} from "../../environments/environment"; // Assuming you have an AuthService

@Injectable({
  providedIn: 'root',
})
export class PsyTestingService {
  private apiUrl = environment.api.url;
  private token: string;

  constructor(private http: HttpClient, private authService: AuthService) {
    // Fetch the token from AuthService
    this.authService.token().subscribe((token) => {
      this.token = token;
    });
  }

  generatePsyTest(userId: number, testTypeId: number): Observable<{ data: any; message: string }> {
    const url = `${this.apiUrl}/psy/generate`; // Replace with the correct endpoint

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}`, // Ensure the token is properly fetched
      }),
    };

    const data = {
      user_id: userId,
      test_type_id: testTypeId,
    };

    return this.http.post<any>(url, data, httpOptions).pipe(
      map((response) => {
        console.log('[psy-testing.service.ts] response', response);

        if (!response.data) {
          throw new Error('Psy test generation failed: ' + response.message);
        }

        return {
          data: response.data,
          message: response.message,
        };
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  savePsyTestAnswers(code: string, answers: { [itemId: number]: number }): Observable<{ data: any; message: string }> {
    const url = `${this.apiUrl}/psy/save-answers`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}`, // Ensure the token is properly fetched
      }),
    };

    const data = {
      code,
      answers,
    };

    return this.http.post<any>(url, data, httpOptions).pipe(
      map((response) => {
        console.log('[psy-testing.service.ts] save answers response', response);

        if (!response.data) {
          throw new Error('Saving answers failed: ' + response.message);
        }

        return {
          data: response.data,
          message: response.message,
        };
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  fetchPsyTestReport(code: string): Observable<{ data: any; message: string }> {
    const url = `${this.apiUrl}/psy/report`; // Replace with the correct endpoint for fetching report

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}`, // Ensure the token is properly fetched
      }),
    };

    const data = {
      code: code,
    };

    return this.http.post<any>(url, data, httpOptions).pipe(
      map((response) => {
        console.log('[psy-testing.service.ts] response', response);

        if (!response.data) {
          throw new Error('Psy test report fetching failed: ' + response.message);
        }

        return {
          data: response.data,
          message: response.message,
        };
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

}
